<template>
  <div @click="handleClick"> 
    <!-- Navbar -->
    <NavbarComponent v-if="showNavbar" />
    <musicaFondo v-if="showmusicaFondo" />

    <BienvenidaPage v-if="showBienvenida" />

    <imgfinal2 v-if="showimgfinal2" />
    <carrusel v-if="showcarrusel" />

    <dondeycuando v-if="showdondeycuando" />
    <fondocambiante v-if="showfondocambiente" />

    <codigovestimenta v-if="showcodigovestimenta" />
    <carrusel2 v-if="showcarrusel2" />

    <mesaRegalos v-if="showmesaRegalos" />

    <mensajeregalos v-if="showmensajeregalos" />
    <!-- Imagen de portada -->
    <confirmacionasistencia
      v-if="showInvitadoEvento && (idInvitado || idFestejado)"
      :id-invitado="Number(idInvitado)"
      :nombre="nombreVariable"
      :id-festejado="Number(idFestejado)"
    />

    <itinerario v-if="showitinerario" />

    <InvitadoEvento 
      v-if="showInvitadoEvento && isValidIdInvitado" 
      :id-invitado="Number(idInvitado)" 
      :nombre="nombreVariable" 
      :id-festejado="Number(idFestejado)" 
    />

    <contador v-if="showcontador" />

    <imagenprimera v-if="showimagenprimera" />

    <padresevento v-if="showpadresevento" />

    <!-- Comprobar si idInvitado es válido antes de mostrar el componente InvitadoEvento -->

    <imgfinal v-if="showimgfinal" />

    <hospedaje v-if="showhospedaje" />

    <blogevento
      v-if="showblogevento"
      :id-invitado="Number(idInvitado)" 
      :nombre="nombreVariable" 
      :id-festejado="Number(idFestejado)" 
    />
    <quotemensaje v-if="showquotemensaje" />

    <carrusel-componente-3 v-if="showcarrusel3" />
    
    <Ventanaemergente v-if="showventana" />

    <img_fixed v-if="showimg_fixed" />
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, watch, computed } from 'vue';
import { useRoute } from 'vue-router';
import NavbarComponent from './narvar.vue';
import BienvenidaPage from './BienvenidaPage.vue';
import imagenprimera from './imagenprimera.vue';
import padresevento from './padresevento.vue';
import dondeycuando from './dondeycuando.vue';
import itinerario from './itinerario.vue';
import mensajeregalos from './mensajeregalos.vue';
import InvitadoEvento from './invitado_evento.vue';
import confirmacionasistencia from './confirmaciónasistencia.vue';
import blogevento from './blog_evento.vue';
import quotemensaje from './quotemensaje.vue';
import imgfinal from './imgfinal.vue';
import img_fixed from './img_fixed.vue';
import musicaFondo from './musica_fondo.vue';
import contador from './contador.vue';
import imgfinal2 from './imagenfinal2.vue';
import mesaRegalos from './regalos';
import codigovestimenta from './codigovestimenta.vue';
import carruselComponente3 from './carruselComponente-3.vue';
import carrusel from './carruselComponent.vue'
import carrusel2 from './Carrusel-Component-2.vue';
import Ventanaemergente from './ventanaemergente.vue';
import fondocambiante from './fondocambiante.vue';
import hospedaje from './hospedaje.vue';

export default {
  name: 'BaseB',
  components: {
    NavbarComponent,
    BienvenidaPage,
    padresevento,
    imagenprimera,
    carrusel,
    dondeycuando,
    fondocambiante,
    itinerario,
    carrusel2,
    mensajeregalos,
    carruselComponente3,
    mesaRegalos,
    hospedaje,
    codigovestimenta,
    InvitadoEvento,
    confirmacionasistencia,
    quotemensaje,
    contador,
    imgfinal2,
    blogevento,
    imgfinal,
    Ventanaemergente,
    img_fixed,
    musicaFondo,
  },
  setup() {
    // Cambiados a true para que se visualicen inmediatamente sin necesidad de un clic
    const showNavbar = ref(true);
    const showBienvenida = ref(true);
    const showimagenprimera = ref(true);
    const showpadresevento = ref(true);
    const showdondeycuando = ref(true);
    const showitinerario = ref(true);
    const showmensajeregalos = ref(true);
    const showmesaRegalos = ref(true);
    const showInvitadoEvento = ref(true);
    const showfondocambiente = ref(true);
    const showconfirmacionasistencia = ref(true);
    const showcontador = ref(true);
    const showquotemensaje = ref(true);
    const showblogevento = ref(true);
    const showimgfinal = ref(true);
    const showimg_fixed = ref(true);
    const showmusicaFondo = ref(true);
    const showventana = ref(true);
    const showcarrusel3 = ref(true);
    const showhashtag = ref(true);
    const showhospedaje = ref(true);
    const showimgfinal2 = ref(true);
    const showcarrusel = ref(true);
    const showcodigovestimenta = ref(true);
    const showcarrusel2 = ref(true);

    // Obtener el parámetro idInvitado de la ruta
    const route = useRoute();
    const idInvitado = ref(Number(route.params.idInvitado) || undefined);
    const idFestejado = ref(Number(route.params.idFestejado) || undefined);
    const nombreVariable = ref(route.params.nombre);

    // Verificar si el idInvitado es válido (no NaN o undefined)
    const isValidIdInvitado = computed(() => {
      return !isNaN(idInvitado.value) && idInvitado.value !== undefined;
    });

    const isValidFestejado = computed(() => {
      return !isNaN(idFestejado.value) && idFestejado.value !== undefined;
    });

    // Observa los cambios en la ruta para actualizar idInvitado
    watch(() => route.params.idInvitado, (newId) => {
      idInvitado.value = Number(newId);
    });

    watch(() => route.params.idFestejado, (newId) => {
      idFestejado.value = Number(newId);
    });
    
    watch(() => route.params.nombre, (newId) => {
      nombreVariable.value = (newId);
    });

    const handleClick = () => {
      console.log('idInvitado:', idInvitado.value);
      console.log('idFestejado:', idFestejado.value);
      console.log('NOMBRE:', nombreVariable.value);

      showNavbar.value = true;
      showBienvenida.value = true;
      showimagenprimera.value = true;
      showpadresevento.value = true;
      showdondeycuando.value = true;
      showitinerario.value = true;
      showimgfinal2.value = true;
      showventana.value = true;
      showfondocambiente.value = true;
      showmensajeregalos.value = true;
      showmesaRegalos.value = true;
      showhashtag.value = true;
      showcarrusel.value = true;
      showInvitadoEvento.value = true;
      showhospedaje.value = true;
      showconfirmacionasistencia.value = true;
      showquotemensaje.value = true;
      showblogevento.value = true;
      showcarrusel3.value = true;
      showcontador.value = true;
      showimgfinal.value = true;
      showcarrusel2.value = true;
      showcodigovestimenta.value = true;
      showimg_fixed.value = true;
      showmusicaFondo.value = true;
    };

    onMounted(() => {
      document.addEventListener('click', handleClick);
    });

    onUnmounted(() => {
      document.removeEventListener('click', handleClick);
    });

    return {
      showNavbar,
      showBienvenida,
      showdondeycuando,
      showmesaRegalos,
      showimgfinal2,
      showquotemensaje,
      
      showimg_fixed,
      showcodigovestimenta,
      showmusicaFondo,
      showcarrusel,
      idInvitado,
      isValidIdInvitado, 
      showitinerario,
      idFestejado,
      nombreVariable,
      isValidFestejado,
      handleClick,
    };
  }
};
</script>

<style scoped>
/* Estilos globales para el contenedor */
</style>